import * as React from "react";
const SvgIcMenuArrowRight = props => <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m7.917 14.583 4.166-4.166L7.917 6.25v8.333Z" /></svg>;
export default SvgIcMenuArrowRight;